import { lastDayOfMonth, addDays, addMonths, addMinutes } from "date-fns";
import { ApiSchemaAppointmentByMonth } from "../models/api";

interface IGenerateEventParams {
  monthStart: string;
  monthEnd: string;
  data: ApiSchemaAppointmentByMonth[];
}

interface IGeneratedEvents {
  start: string;
  end: string;
}

export interface IEventData {
  appointmentId: string;
  caregiverName: string;
  patientName: string;
}

function getRequiredTimeFrame(
  appointment: ApiSchemaAppointmentByMonth,
  monthStart: string,
  monthEnd: string
) {
  const start = {
    date: 1,
    month: 0,
    ISODate: "",
  };
  const end = {
    date: 1,
    month: 0,
  };
  const appointmentStartDateObj = new Date(appointment.taskStartTime);
  const appointmentEndDateObj = new Date(appointment.appointmentEndDate);
  const calendarStartDateObj = new Date(monthStart);
  const calendarEndDateObj = new Date(monthEnd);
  calendarStartDateObj.setHours(
    appointmentStartDateObj.getHours(),
    appointmentStartDateObj.getMinutes(),
    appointmentStartDateObj.getSeconds()
  );
  const calendarStartMonth = calendarStartDateObj.getTime();
  const appointmentStartMonth = appointmentStartDateObj.getTime();
  const calendarEndMonth = calendarEndDateObj.getTime();
  const appointmentEndMonth = appointmentEndDateObj.getTime();
  if (calendarStartMonth > appointmentStartMonth) {
    start.month = calendarStartDateObj.getMonth();
    start.date = calendarStartDateObj.getDate();
    start.ISODate = calendarStartDateObj.toISOString();
  } else {
    start.month = appointmentStartDateObj.getMonth();
    start.date = appointmentStartDateObj.getDate();
    start.ISODate = appointmentStartDateObj.toISOString();
  }
  if (calendarEndMonth < appointmentEndMonth) {
    end.month = calendarEndDateObj.getMonth();
    end.date = calendarEndDateObj.getDate();
  } else {
    end.month = appointmentEndDateObj.getMonth();
    end.date = appointmentEndDateObj.getDate();
  }
  return { start, end };
}

export function generateEvent({
  monthStart,
  monthEnd,
  data,
}: IGenerateEventParams) {
  const generatedEvents: IGeneratedEvents[] = [];
  for (const appointment of data) {
    const { start, end } = getRequiredTimeFrame(
      appointment,
      monthStart,
      monthEnd
    );
    let currentMonth = start.month;
    let currentDate = start.ISODate;

    for (let i = start.month; i <= end.month; i++, currentMonth++) {
      const startISODate =
        currentMonth === start.month ? start.ISODate : currentDate;
      const startDateOfMonth = currentMonth === start.month ? start.date : 1;
      const endDateOfMonth = lastDayOfMonth(new Date(currentDate)).getDate();
      let dayToAdd = 0;
      for (let j = startDateOfMonth; j <= endDateOfMonth; j++, dayToAdd++) {
        const event = {
          start: "",
          end: "",
          extendedProps: {
            appointmentId: appointment.sKey,
            caregiverName: appointment.caregiverName,
            patientName: appointment.patientName,
          },
        };
        const start = addDays(new Date(startISODate), dayToAdd);
        event.start = start.toISOString();
        event.end = addMinutes(start, appointment.maxHours * 60).toISOString();
        generatedEvents.push(event);
        if (currentMonth === end.month && end.date === start.getDate()) {
          break;
        }
      }
      const startDateObj = new Date(startISODate);
      startDateObj.setDate(1);
      currentDate = addMonths(startDateObj, 1).toISOString();
    }
  }
  return generatedEvents;
}

export const Dashboard = {
  generateEvent,
};
